export default __webpack_public_path__ + "static/media/aqi_4.860c53ce.svg";